<template>
    <rkm-overlay :show="loading">
        <rkm-form
            class="login-form"
            ref="RkmForm"
        >
            <h2>Recuperar senha</h2>

            <p class="subtitle">
                Digite suas informações abaixo para redefinir sua senha
            </p>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.cpf_numero"
                        name="CPF"
                        placeholder="Digite seu CPF"
                        v-mask="utils.mask.cpf"
                        v-model="model.cpf_numero"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon :icon="['far', 'id-card']" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.email"
                        name="E-mail"
                        placeholder="Digite seu e-mail"
                        type="email"
                        v-model="model.email"
                    >
                        <rkm-input-group-prepend slot="prepend">
                            <rkm-input-group-text>
                                <rkm-icon :icon="['far', 'envelope']" />
                            </rkm-input-group-text>
                        </rkm-input-group-prepend>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <div class="login-form-actions">
                        <rkm-row>
                            <rkm-col>
                                <rkm-button
                                    :disabled="loading"
                                    @click="handleRecovery"
                                    block
                                    color="primary"
                                >
                                    Enviar informações
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <rkm-link :to="{name: 'login'}">
                                    <rkm-icon :icon="['fas', 'arrow-left']" class="me-1" /> Voltar ao login
                                </rkm-link>
                            </rkm-col>
                        </rkm-row>
                    </div>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </rkm-overlay>
</template>

<script>
// Mixins.
import {error, notification} from '@/mixins'

// Utils.
import mask from '@/utils/mask'
import unmask from '@/utils/unmask'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('autenticacao-recuperar-senha-form')
        },
         validations() {
            return {
                cpf_numero: {
                    required: true,
                    cpf: true,
                },
                email: {
                    required: true,
                    email: true,
                },
            }
        },
    },
    data: () => ({
        model: {
            cpf_numero: null,
            email: null,
        },
        utils: {
            mask,
            unmask,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions([
            'clearLocalStorage',
            'setLoading',
            'unsetLoading',
        ]),
        handleRecovery() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated === true) {
                        this.setLoading('autenticacao-recuperar-senha-form')

                        const request = {
                            cpf_numero: this.utils.unmask.cpf(this.model.cpf_numero),
                            email: this.model.email,
                        }

                        this.repositories.autenticacao.recovery(request)
                            .then(({data}) => {
                                this.showSuccessNotification(null, data.message)
                                this.clearLocalStorage().then(() => this.$router.push({name: 'login'}))
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('autenticacao-recuperar-senha-form'))
                    }
                })
        },
    },
    mixins: [error, notification],
}
</script>